import React from 'react';

class Ibox extends React.Component 
{
    constructor(props)
    {
        super(props);
    }

    render() 
    {
        const props = this.props;

        return (
            <div className="ibox">
                <div className="ibox-title">
                    <h5>{props.name}</h5>
                </div>
                <div className="ibox-content">
                    <h1 className="no-margins">{props.val}</h1>
                    
                    <small>{props.obs}</small>
                </div>
            </div>
        )
    }
}

export default Ibox
